<template>
  <div class="header">
    <div class="logo">
      <img src="../assets/header.png" class="header-logo" />
      <Burger
        v-if="isMobile()"
        v-on:click="$refs.sidebar.openSidebarPanel()"
        class="burger"
      ></Burger>
      <Sidebar ref="sidebar" class="sidebar">
        <ul
          v-on:click="$refs.sidebar.closeSidebarPanel()"
          class="sidebar-panel-nav"
        >
          <li><a href="/#mint">mint</a></li>
          <li><a href="/#roadmap">road map</a></li>
          <li><a href="/#creators">creators</a></li>
          <li><a href="/#patches">patches</a></li>
          <li><a href="/#link-to-opensea">opensea</a></li>
        </ul>
      </Sidebar>
      <div class="social-nav">
        <a href="https://opensea.io/collection/lemurians">
          <img class="image" src="../assets/2aOpensea.png"
        /></a>
        <a href="https://discord.gg/QXzYJSWVnJ">
          <img class="image" src="../assets/2aDiscord.png"
        /></a>
        <a href="https://twitter.com/Lemurians_io">
          <img class="image" src="../assets/2aTwitter.png"
        /></a>
      </div>
      <a class="btn-connect" v-if="!connected" v-on:click="connect()">
        <img class="image img-btn-connect" src="../assets/connectbutton.png"
      /></a>
    </div>
    <div v-if="!isMobile()" class="menu">
      <ul>
        <li><a href="/#mint">mint</a></li>
        <li><a href="/#roadmap">road map</a></li>
        <li><a href="/#creators">creators</a></li>
        <li><a href="/#patches">patches</a></li>
        <li><a href="/#link-to-opensea">opensea</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Web3EthContract from "web3-eth-contract";
import abi from "@/components/json/abi.json";
import Configuration from "../configuration.json";
import Burger from "./menu/Burger.vue";
import Sidebar from "./menu/Sidebar.vue";
const { ethereum } = window;
const smartContract = new Web3EthContract(
  abi,
  Configuration.smartContractAddress
);

export default {
  name: "Header",
  components: {
    Burger,
    Sidebar,
  },
  computed: {
    connected() {
      return this.$store.getters.getConnected;
    },
  },
  methods: {
    loadData: async (component) => {
      await ethereum.enable();
      await ethereum.request({
        method: "eth_requestAccounts",
      });
      await smartContract.setProvider(ethereum);
      component.$forceUpdate();
    },
    connect() {
      const metaMaskinstalled = this.detectMetaMask();
      if (metaMaskinstalled) {
        console.log("MetaMask is installed!");
      } else {
        return;
      }
      ethereum.on("chainChanged", () => {
        window.location.reload();
      });
      ethereum.on("accountsChanged", () => {
        window.location.reload();
      });
      this.loadData(this);
    },
    detectMetaMask() {
      return ethereum && ethereum.isMetaMask;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
.burger {
  padding-top: 15px;
  padding-left: 15px;
  float: right;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 1000;
}

.img-btn-connect {
  margin-right: 50px;
  margin-top: 50px;
}

.logo {
  position: relative;
}

.header-logo {
  max-width: 100%;
  height: auto;
  width: auto\9; /* ie8 */
}
.btn-connect {
  float: right;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1000;
}

.btn-connect:hover {
  opacity: 0.9;
}

.header {
  background: radial-gradient(
    circle,
    rgba(32, 136, 112, 1) 0%,
    rgba(58, 80, 106, 1) 92%
  );
  position: relative;
}

.menu {
  margin-top: 30px;
  background: rgb(54, 161, 134);
  background: linear-gradient(
    180deg,
    rgba(54, 161, 134, 1) 0%,
    rgba(98, 157, 174, 1) 60%
  );
}
.social-nav {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  gap: 90px;
  margin-right: 30px;
}
.nav {
  margin: auto;
  height: 1205px;
  width: 1900px;
  background: url(../assets/header.png) center center no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
}

/* menu */
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
}
li {
  display: inline-block;
  min-width: 5em;
  margin: 0 2.5em;
}
li:hover {
  color: #fff;
}
li a {
  display: block;
  font-family: Phenomenopolisb;
  font-style: normal;
  font-weight: normal;
  font-size: 64px;
  text-align: center;
  color: #b3e8ff;
  padding: 14px 16px;
  text-decoration: none;
  text-shadow: 0 0 7px #b3e8ff, 0 0 10px #b3e8ff, 0 0 21px #b3e8ff;
}
li a:hover {
  color: #fff;
}

.sidebar-panel-nav li {
  margin-left: 4px;
}

.sidebar-panel-nav li a {
  text-align: left;
  font-size: 24px;
}

@media only screen and (max-width: 768px) {
  .nav {
    background-size: 100%;
    min-height: 300px;
    height: 100%;
  }

  .btn-connect {
    position: initial;
    margin-top: 10px;
  }

  .social-nav {
    position: inherit;
    margin-right: 0px;
  }

  .img-btn-connect {
    margin-right: 0px;
    margin-top: 0px;
  }

  .header {
    background: none;
  }
}
</style>
